import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

export default function BusinessPublicRoute() {
  const { isAuthenticated, user } = useSelector((state) => state.auth);

  if (isAuthenticated && user?.role === "business") {
    return <Navigate to="/business/dashboard" replace />;
  }

  return <Outlet />;
}
